namespace Solovis.UI.StockAnimations {

    /*
     * @typedef {Object} Solovis_UI_StockAnimations_Options
     * @property {number} diameter - diameter of the circle animation
     * @property {string} top - top position of the animation.  Can be a number, px, or %
     * @property {string} left - left position of the animation.  Can be a number, px, or %
     * @property {bool} showShadow - whether to display a shadow in the animation
     */
    /*
     * @description Creates a div that displays an animation of 2 concentric circles with the outer circle
     *  spinning counterclockwise and fading in and out, and the inner circle spinning clockwise
     * @param {Solovis_UI_StockAnimations_Options} options
     * @returns a jquery element div containing the animations
     */
    export function createSpinningCircles(options) {

        var diameter = Solovis.isNotNull(options.diameter) ? options.diameter.toString() : 0;
        var left = Solovis.isNotNull(options.left) ? options.left.toString() : 0;
        var top = Solovis.isNotNull(options.top) ? options.top.toString() : 0;
        var showShadow = options.showShadow ? options.showShadow : false;

        // Trim the "px" off so we can calculate margins, etc.
        if (diameter && diameter.indexOf("px") !== -1) {
            diameter = diameter.replace("px", "");
        }

        if (top && $.isNumeric(top)) {
            top = top + "px";
        }

        if (left && $.isNumeric(left)) {
            left = left + "px";
        }

        var containerDiv = $("<div>").addClass("circle-animation-container");

        var innerCircleDiv = $("<div>")
            .addClass("circle inner-animation")
            .appendTo(containerDiv);

        var outerCircleDiv = $("<div>")
            .addClass("circle outer-animation")
            .appendTo(containerDiv);

        if (showShadow) {
            var brandDarkHex = Solovis.UI.Colors.getHexValue("brand_dark");
            var brandDarkestHex = Solovis.UI.Colors.getHexValue("brand_darkest");

            innerCircleDiv
                .addClass("show-shadow")
                .css("box-shadow", "0 0 " + (diameter / 6) + "px " + brandDarkHex);

            outerCircleDiv
                .addClass("show-shadow")
                .css("box-shadow", "0 0 " + (diameter / 3) + "px " + brandDarkHex);

            var brandDarkestRGB = Solovis.UI.Colors.hexToRgb(brandDarkestHex);

            containerDiv.css("background-color", "rgba(" +
                brandDarkestRGB.r + "," +
                brandDarkestRGB.g + "," +
                brandDarkestRGB.g + "," +
                "0.3");
        }



        containerDiv.css({
            "width": diameter + "px",
            "height": diameter + "px",
            "border-radius": diameter + "px",
            "margin": "-" + (diameter / 2) + "px 0 0 -" + (diameter / 2) + "px",
            "top": top,
            "left": left,
            "pointer-events": "none"
        });

        outerCircleDiv.css({
            "border-width": (diameter / 10) + "px",
            "width": diameter + "px",
            "height": diameter + "px",
            "border-radius": diameter + "px",
            "margin": "-" + (diameter / 2) + "px 0 0 -" + (diameter / 2) + "px"
        });

        innerCircleDiv.css({
            "border-width": (diameter / 10) + "px",
            "width": (diameter * .6) + "px",
            "height": (diameter * .6) + "px",
            "border-radius": (diameter / 2) + "px",
            "margin": "-" + (diameter * .3) + "px 0 0 -" + (diameter * .3) + "px"
        });

        return containerDiv;
    }

}
